import React, { Component } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";

class EmptyView extends Component {
  render() {
    return <Layout {...this.props} type="EmptyView" />;
  }
}

EmptyView.propTypes = {
  childOf: PropTypes.string,
  values: PropTypes.object,
  cell: PropTypes.array,
  layout: PropTypes.func
};

export default EmptyView;



// WEBPACK FOOTER //
// ./src/contents/editorPreview/layout/components/Content/EmptyView.js